<template>
  <f7-panel left class="panelBackground">

    <!-- DR: Icone pour enelever le close-panel (MobileLeftPanel) -->
    <div>
      <f7-link
        class="headbandTextColor"
         close-picker close-panel="left">
        <i class="fa-solid fa-xmark iconRemovePanel"></i>
      </f7-link>
    </div>

    <!-- Identity header -->
    <mobile-language-picker></mobile-language-picker>
    <mobile-norm-picker v-if="hasAtLeastTwoRightNorm" :checkedNorm="checkedNorm" :norms="norms"></mobile-norm-picker>
    <mobile-identity-header :username="userName"/>

    <div class="overflow-y-auto overflow-x-hidden h-100vh">
      <!-- Profile options container -->
      <mobile-menu-container>
        <mobile-menu-section-list-item
          class="profileInformationContainer"
          labelId="leftPanelTitle.accueil"
          @click="goToLink('/home/')">
        </mobile-menu-section-list-item>
        <mobile-menu-section-list-item
          class="profileInformationContainer"
          labelId="leftPanelTitle.my_prfl"
          @click="goToLink('/profile/')">
        </mobile-menu-section-list-item>
        <mobile-menu-section-list-item
          class="profileInformationContainer"
          labelId="leftPanelTitle.swtch_prfl"
          @click="activateModalProfile">
        </mobile-menu-section-list-item>
        <!-- <mobile-menu-section-list-item
          class="profileInformationContainer"
          labelId="Webheader.settings"
          @click="goToLink('/settings/application/')">
        </mobile-menu-section-list-item> -->
        <mobile-menu-section-list-item
          v-if="this.accountType === '1'"
          class="profileInformationContainer"
          labelId="Webheader.company_members"
          @click="goToLink('/accountMembers/')">
        </mobile-menu-section-list-item>
        <mobile-menu-section-list-item
          class="profileInformationContainer"
          labelId="leftPanelTitle.lgout"
          @click="logoutWait">
        </mobile-menu-section-list-item>
      </mobile-menu-container>

      <hr />

      <!-- Navigation menu -->
      <mobile-menu-container>
        <!-- Section (with included header) -->
        <mobile-menu-section
          v-for="item in menu" :key="item.id"
          v-if="!isDisabledItem(item) && item.enabled"
          :headerLabelId="hasOneRight(item.list) ? item.titleShort : ''">

            <!-- if List of items -->
            <div v-if="item.list">
              <mobile-menu-section-list-item
                v-for="subItem in item.list" :key="subItem.id"
                v-if="subItem.id !== 0 && !isDisabledItem(subItem) && subItem.enabled"
                class="ml-20px"
                :labelId="subItem.titleShort"
                @click="getClicked(subItem)">
              </mobile-menu-section-list-item>
            </div>

            <!-- else if One item with link -->
            <div v-else-if="item.link">
              <mobile-menu-section-list-item
                :labelId="item.title"
                :disabled="isDisabledItem(item)"
                @click="goToLink(item.link)">
              </mobile-menu-section-list-item>
            </div>
        </mobile-menu-section>
      </mobile-menu-container>
    </div>
  </f7-panel>
</template>

<script>
import MobileLanguagePicker from '@/components/menus/MobileMenuComponents/MobileLanguagePicker'
import MobileMenuContainer from '@/components/menus/MobileMenuComponents/MobileMenuContainer'
import MobileMenuSection from '@/components/menus/MobileMenuComponents/MobileMenuSection'
import MobileMenuSectionListItem from '@/components/menus/MobileMenuComponents/MobileMenuSectionListItem'
import MobileNormPickerVue from './MobileMenuComponents/MobileNormPicker.vue'
import MobileIdentityHeader from '@/components/menus/MobileMenuComponents/MobileIdentityHeader'

import Services from '@/helpers/services'
import {reloadPage2} from './../../helpers/routing'

export default {
  name: 'MobileLeftPanel',
  components: {
    'mobile-identity-header': MobileIdentityHeader,
    'mobile-language-picker': MobileLanguagePicker,
    'mobile-menu-container': MobileMenuContainer,
    'mobile-menu-section': MobileMenuSection,
    'mobile-menu-section-list-item': MobileMenuSectionListItem,
    'mobile-norm-picker': MobileNormPickerVue
  },
  props: {
    context: {
      default: 'generic',
      type: String
    }
  },
  data () {
    return {
      accountType: '0',
      checkedNorm: 0,
      currentLink: '',
      currentSubitem: {},
      lastSetNorm: 0,
      menu: [],
      norms: [],
      resetMenu: false,
      userName: '',
      windowWidth: window.innerWidth,
    }
  },
  created () {
    if (this.context && this.context !== 'generic') {
      this.menuLinkList = require('./data/menu_' + this.context + '.json')
    } else {
      this.menuLinkList = require('./data/menu.json')
    }
    this.menu = this.menuLinkList['linkContent']
    this.norms = [
      {value: 1, text: this.$t('Webheader.norm_srtp'), condition: this.hasRightSRTP},
      {value: 2, text: this.$t('Webheader.norm_hrtp'), condition: this.hasRightHRTP},
      {value: 3, text: this.$t('Webheader.norm_psd2'), condition: this.hasRightPSD2}
    ]
    this.setCheckedNorm()
    this.userName = this.$engine.user.get().name
    this.accountType = this.$engine.user.get().type
    // window.addEventListener('resize', this.handleResize)
    let that = this
    this.$bus.$on('refresh-cache-menu', () => {
      this.userName = this.$engine.user.get().name
      this.accountType = this.$engine.user.get().type
    })
    this.$bus.$on('switch-selected-menu', function(newUrl) {
      that.currentLink = newUrl
    })
    if (this.$engine.auth.isAuth() && this.$f7.getCurrentView().url === '/login/') {
      this.currentLink = '/home/'
    } else {
      //this.currentLink = this.$f7.getCurrentView().url
      this.verifyCurrentView()
    }
    this.$bus.$on('change-norm', (norm, isClick) => {
      this.changeNorm(norm, isClick)
    })
    this.canUserSeePage()
  },
  methods: {
    activateModalProfile () {
      this.$f7.popup('#switch-profile-true')
    },
    canUserSeePage () {
      let currentPage = {}
      let that = this
      this.menu.forEach((page) => {
        if (page.link === this.currentLink) {
          currentPage = page
          return
        } else if (page.list && page.list.length > 0) {
          page.list.forEach((subpage) => {
            if (subpage.link === this.currentSubitem.link) {
              currentPage = subpage
              return
            }
          })
        }
      })
      if (Object.keys(currentPage).length === 0) {
        return
      }
      if (this.$engine.user.getUserNorm() && currentPage.norm_disable) {
        if (this.$engine.user.getUserNorm() === '1') {
          if (this.$engine.rights.rightIs(currentPage.norm_disable.SRTP.right, currentPage.norm_disable.SRTP.state)) {
            reloadPage2(that, '/home/')
            that.goToLink('/home/')
          }
        } else if (this.$engine.user.getUserNorm() === '2') {
          if (this.$engine.rights.rightIs(currentPage.norm_disable.HRTP.right, currentPage.norm_disable.HRTP.state)) {
            reloadPage2(that, '/home/')
            that.goToLink('/home/')
          }
        } else if (this.$engine.user.getUserNorm() === '3') {
          if (this.$engine.rights.rightIs(currentPage.norm_disable.PSD2.right, currentPage.norm_disable.PSD2.state)) {
            reloadPage2(that, '/home/')
            that.goToLink('/home/')
          }
        }
      }
    },
    changeNorm (norm, isClick = false) {
      let currentPage = {}
      let that = this
      this.checkedNorm = norm
      this.menu.forEach((page) => {
        if (page.link === this.currentLink) {
          currentPage = page
          return
        } else if (page.list && page.list.length > 0) {
          page.list.forEach((subpage) => {
            if (subpage.link === this.currentSubitem.link) {
              currentPage = subpage
              return
            }
          })
        }
      })
      if (this.checkedNorm === this.lastSetNorm) {
        return
      } else {
        this.$engine.user.setUserNorm(this.checkedNorm.toString(10))
        this.lastSetNorm = this.checkedNorm
        if (currentPage.norm_disable || this.currentLink === '/home/' || this.currentLink === '/settings/rtpSettings/') {
          reloadPage2(that, that.currentLink)
        }
        if (isClick === true) {
          this.$bus.$emit('reset-webheader')
          this.canUserSeePage()
        }
      }
    },
    getClicked (subitem) {
      if (!subitem.link) {
        return
      }
      this.currentLink = ''
      this.currentSubitem = subitem
      this.Dom7('.panel-left').on('panel:closed', this.loadPageFromRoute)
    },
    goToLink (linkToGo) {
      this.currentSubitem = {}
      this.currentLink = linkToGo
      this.Dom7('.panel-left').on('panel:closed', this.loadPageFromLink)
    },
    handleResize () {
      let that = this
      that.windowWidth = window.innerWidth
      that.$engine.services.directPayments.filter.smartphoneStorage = !that.isLaptop
      that.$bus.emit('window-resize')
    },
    hasOneRight (itemList) {
      let that = this
      if(itemList !== undefined) {
        return itemList.filter(item => {
          return !that.isDisabledItem(item)
        }).length
      } else {
        return false
      }
    },
    isDisabledItem (item) {
      if (item && !item.enabled) {
        return true
      }
      if (item && item.right_disable && item.right_disable.right) { // If item has a right value
        if (item.right_disable.right === 'rights_profile_consult') {
          return this.$engine.user.get().id === this.$engine.user.get()
          ? this.$engine.rights.rightIs('rights_admin_consulter', item.right_disable.state)
          : this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
        }
        // Return true if the right has the same state as the disabling state
        if (item && item.norm_disable && this.$engine.user.getUserNorm()) {
          if (this.$engine.user.getUserNorm() === '1') {
            return this.$engine.rights.rightIs(item.norm_disable.SRTP.right, item.norm_disable.SRTP.state)
          } else if (this.$engine.user.getUserNorm() === '2') {
            return this.$engine.rights.rightIs(item.norm_disable.HRTP.right, item.norm_disable.HRTP.state)
          } else if (this.$engine.user.getUserNorm() === '3') {
            return this.$engine.rights.rightIs(item.norm_disable.PSD2.right, item.norm_disable.PSD2.state)
          }
        } else {
          return this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
        }
      }
      return false
    },
    logout () {
      this.Dom7('.panel-left').off('panel:closed')
      this.$bus.emit('logout')
    },
    logoutWait () {
      this.Dom7('.panel-left').on('panel:closed', this.logout)
    },
    loadPageFromLink () {
      let that = this
      this.Dom7('.panel-left').off('panel:closed')
      reloadPage2(that, this.currentLink)
    },
    loadPageFromRoute () {
      this.Dom7('.panel-left').off('panel:closed')
      let subitem = this.currentSubitem
      let that = this
      reloadPage2(that, subitem.link)
    },
    setCheckedNorm () {
      if (this.hasRightSRTP && !this.hasRightHRTP && !this.hasRightPSD2) {
        this.checkedNorm = 1
        this.changeNorm(this.checkedNorm)
      } else if (!this.hasRightSRTP && this.hasRightHRTP && !this.hasRightPSD2) {
        this.checkedNorm = 2
        this.changeNorm(this.checkedNorm)
      } else if (!this.hasRightSRTP && !this.hasRightHRTP && this.hasRightPSD2) {
        this.checkedNorm = 3
        this.changeNorm(this.checkedNorm)
      } else if (this.hasAtLeastTwoRightNorm) {
        this.$engine.user.getUserNorm()
        let normAnswer = this.$engine.user.getUserNorm()
        if ((normAnswer === '1' && this.hasRightSRTP) || (normAnswer === '2' && this.hasRightHRTP) || (normAnswer === '3' && this.hasRightPSD2)) {
          normAnswer === '1' ? this.checkedNorm = 1 : normAnswer === '2' ? this.checkedNorm = 2 : this.checkedNorm = 3
        } else {
          let randomNumber = Math.floor(Math.random() * 3);
          if (randomNumber === 0) {
            this.checkedNorm = 1
          } else if (randomNumber === 1) {
            this.checkedNorm = 2
          } else {
            this.checkedNorm = 3
          }
        }
        this.changeNorm(this.checkedNorm)
      } else {
        if (this.$engine.user.getUserNorm()) {
          this.$engine.user.deleteUserNorm()
        }
        return
      }
    },
    verifyCurrentView () {
      let pageExistsInMenu = false
      let that = this
      this.menu.forEach((page) => {
        if (page.link === this.$f7.getCurrentView().url) {
          pageExistsInMenu = true
          return
        } else if (page.list && page.list.length > 0) {
          page.list.forEach((subpage) => {
            if (subpage.link === this.$f7.getCurrentView().url) {
              pageExistsInMenu = true
              return
            }
          })
        }
      })
      if (pageExistsInMenu === true || this.$f7.getCurrentView().url === '/home/' || this.$f7.getCurrentView().url === '/profile/' || this.$f7.getCurrentView().url === '/settings/application/') {
        this.currentLink = this.$f7.getCurrentView().url
      } else {
        //Pour le cas des détails Dashboard par exemple DRO 02/08/2024
        this.currentLink = this.$f7.mainView.history[this.$f7.mainView.history.length - 1]
      }
    }
  },
  computed: {
    hasAtLeastTwoRightNorm () {
      let rightNormCounter = 0
      if (this.hasRightHRTP === true) {
        rightNormCounter += 1
      }
      if (this.hasRightPSD2 === true) {
        rightNormCounter += 1
      }
      if (this.hasRightSRTP === true) {
        rightNormCounter += 1
      }
      return rightNormCounter >= 2
    },
    hasRightHRTP () {
      let currentRights = this.$engine.rights.getAll()
      let rightHRTPFound = false
      Object.entries(currentRights).forEach((right) => {
        if (right[0].includes('_hrtp') && right[1] === true) {
          rightHRTPFound = true
        }
      })
      return rightHRTPFound
    },
    hasRightPSD2 () {
      let currentRights = this.$engine.rights.getAll()
      let rightsPSD2Found = false
      Object.entries(currentRights).forEach((right) => {
        if (right[0].includes('_psd2') && right[1] === true) {
          rightsPSD2Found = true
        }
      })
      return rightsPSD2Found
    },
    hasRightSRTP () {
      let currentRights = this.$engine.rights.getAll()
      let rightSRTPFound = false
      Object.entries(currentRights).forEach((right) => {
        if (right[0].includes('_srtp') && right[1] === true) {
          rightSRTPFound = true
        }
      })
      return rightSRTPFound
    },
    isLaptop () {
      return this.windowWidth >= 1024
    }
  }
}
</script>
